import styled, { css } from "styled-components";
import { animated } from "@react-spring/web";
import { buildColor } from "@tvg/design-system";

// TODO => if it's tvg scope make sure to increase top spacing
// depending on the tvg header height
export const Container = styled.div<{
  isFdr?: boolean;
}>`
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: ${({ isFdr }) => (isFdr ? "0" : "var(--hdr-height, 76px)")};
  z-index: 5;
  padding: 4px 12px 4px 6px;
  background-color: ${({ theme }) => theme.colorTokens.background.secondary};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TrackInfoWrapper = styled(animated.div)`
  display: flex;
  flex: auto;
  flex-direction: column;

  > div:last-child {
    font-size: 14px;
    line-height: 125%;
  }
`;

export const TrackInfoContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

const HeaderTextDefaultContainer = css`
  font-size: 14px;
  line-height: 125%;
  color: ${buildColor("blue", "000")};
  font-family: "Roboto-Bold", sans-serif;
`;

export const TrackNameContainer = styled.span`
  ${HeaderTextDefaultContainer};
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RaceNumberContainer = styled.span`
  ${HeaderTextDefaultContainer};
  padding-right: 2px;
`;

export const IconWrapper = styled(animated.div)`
  margin-right: 4px;
`;

export const TitleComputationContainer = styled.span`
  position: fixed;
  z-index: -5;
  top: 0;
  visibility: hidden;
`;
